module.exports = __webpack_public_path__ + "media/looknfeel.67a97ebd.mp4";